module.exports = __webpack_public_path__ + "static/02-owl-laptop-study 1-a46908ea24cd5571dde422882645bc33.svg";